export default __webpack_public_path__ + "kefu-icon91142d.svg";